<template>
  <div class="card__wrap">
    <div v-if="simcard" class="card" >
      <div class="header-profile" :class="{blocked: simcard.blocked}">
        <div class="icons">

          <span class="badge" :class="simcard_status_color(+simcard.status)">
            {{simcard_status_text(+simcard.status)}}
          </span>

          <div class="last_update">
            <span> {{ translate('status') }} {{ simcard_status_text(+simcard.status) }} </span>
            <span> {{get_status_from}} </span>
          </div>

        </div>

        <div class="download_to_device">
          <h4 class="title">{{ simcard.device_info ? translate('esim_profile.esim_not_free') : translate('esim_profile.esim_free') }}</h4>

          <div v-if="simcard.device_info" class="current">
            <div class="version">
              <span>
                Device ID: {{ simcard.device_info.device_id }}
                FID: {{ simcard.device_info.device_fid }}
                Slot: {{ simcard.device_info.device_slot }}
              </span>
              <span> User: {{ simcard.device_info.upload_username }} Date: {{ get_date(simcard.device_info.ts_upload) }} </span>
            </div>

            <button class="btn-success btn-fill btn-wd marginButton" @click.prevent="upload_to_device" >
              {{ translate('esim_profile.new_upload') }}
            </button>
          </div>

          <div v-else class="download">
            <button
              class="btn-success btn-fill btn-wd marginButton"
              @click.prevent="download_to_device()"
            >
              {{ translate('esim_profile.new_download') }}
            </button>
          </div>
        </div>

        <div class="linked-cards">
          <div class="linked-card__wrap" v-for="(link, key) in links" :key="key">
            <LinkedSimCard
              v-if="link != null"
              :title="key"
              :simcard="link"
            />
          </div>
        </div>

        <div v-if="profile.blocked" class="esim_blocked">
          <span>{{translate('esim_profile.blocked_use')}}</span>
        </div>

      </div>

      <div class="device_list">
        <DeviceHistory
          :profile="simcard"
        />
      </div>

      <div class="content">
        <div v-if="simcard.traffic" class="traffic__wrap">
          <div class="traffic" :style="style_traffic">
            <p v-if="simcard.traffic.balance_limit && simcard.traffic.ts_update">
              <b :style="'color:' + balance_trafic.color"> {{balance_trafic.trafic}} </b>
              <span>
                {{this.translate("simcard_devices.out_of")}}
                <b>
                  {{parseInt(simcard.traffic.balance_limit/1024)}} GB
                </b>
              </span>
            </p>
          </div>
          <div class="last_update" v-if="simcard.traffic.balance_limit && simcard.traffic.ts_update">
            <p>
              {{translate('simcard_devices.updated')}}
              {{last_update}}
            </p>
          </div>
        </div>

        <form class="simcard-profile">
          <div class="row">
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.msisdn"
                type="text"
                :label="translate('esim_profile.msisdn')"
                :placeholder="translate('esim_profile.msisdn')"
                :readonly="true"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.imsi"
                type="text"
                :label="translate('esim_profile.imsi')"
                :placeholder="translate('esim_profile.imsi')"
                :readonly="true"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.iccid"
                type="text"
                :label="translate('esim_profile.iccid')"
                :placeholder="translate('esim_profile.iccid')"
                :readonly="true"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.mno_name"
                type="text"
                :label="translate('esim_profile.mno')"
                :placeholder="translate('esim_profile.mno')"
                :readonly="true"
              />
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.parent_mno"
                type="text"
                :label="translate('esim_profile.parent_mno')"
                :placeholder="translate('esim_profile.parent_mno')"
                :readonly="true"
              >
              </fg-input>
            </div>
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.tariff"
                type="text"
                :label="translate('esim_profile.tariff')"
                :placeholder="translate('esim_profile.tariff')"
                :readonly="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-6">
              <fg-input
                v-model="simcard.username"
                type="text"
                :label="translate('esim_profile.username')"
                :placeholder="translate('esim_profile.username')"
                :readonly="true"
              />
            </div>
            <div class="col-md-6 col-sm-6">
              <fg-input
                v-model="created"
                type="text"
                :label="translate('esim_profile.ts_create')"
                :placeholder="translate('esim_profile.ts_create')"
                :readonly="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="clearfix" />
        </form>

      </div>

      <div class="simcard_list">
        <RelatedProfiles
          v-if="simcard.virt_profiles"
          title="Related Profiles"
          :simcard_list="simcard.virt_profiles"
        />
      </div>

      <div class="text-center">
        <span
          type="submit"
          class="btn btn-danger btn-wd"
          @click="blockedEsim()"
          v-if="this.$store.getters.getPermissions.permissionGod === true"
        >
        {{ (!simcard.blocked)? this.translate('block') : this.translate('unblock') }}
        </span>
      </div>
    </div>


    <div class="history_action__wrap">
      <Summary
        type="esim_profile"
        :info="simcard"
      />
    </div>
  </div>

</template>
<script>

import RelatedProfiles from './RelatedProfiles.vue'
import LinkedSimCard from 'components/UIComponents/Icon/LinkedSimCard.vue'
import DeviceHistory from './DeviceHistory.vue'
import DownloadToDevice from './DownloadToDevice.vue'
import UploadToDevice from './UploadToDevice.vue'
import ModalBlock from './ModalBlock.vue'
import Summary from "@/views/Dashboard/common/General/Summary.vue";

export default {
  components: {
    RelatedProfiles,
    LinkedSimCard,
    DeviceHistory,
    Summary
  },

  props: {
    profile: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    this.update_sim()
    this.check_links(this.simcard)
  },
  data () {
    return {
      ch_group: false,
      showBlock: true,
      simcard: {
        type: [Array, Object],
        default: () => []
      },
      editNumber: true,
      editOperator: true,
      links: {}
    }
  },

  computed: {
    opt_groups () {
     return this.$store.getters.getSimcardDevicesGroupsTree
    },
    balance_trafic(){
      if (!this.simcard.traffic) return null

      let trafic_GB = +this.simcard.traffic.balance_value / 1024
      if (trafic_GB > 5) {
        return {trafic: Math.round(trafic_GB), color: 'black'}
      }else if (trafic_GB > 1) {
        return {trafic: Math.round(trafic_GB), color: 'orange'}
      }
      return {trafic: this.simcard.traffic.balance_value + ' MB', color: 'red'}
    },

    style_traffic(){
      let percent = this.simcard.traffic.balance_value / this.simcard.traffic.balance_limit * 100

      let trafic_GB = +this.simcard.traffic.balance_value / 1024
      if (trafic_GB > 5) {
        return '--p:' + percent + ';--c:green;'
      }else if (trafic_GB > 1) {
        return '--p:' + percent + ';--c:orange;'
      }
      return '--p:' + percent + ';--c:red;'

    },

    last_update(){
      let ts = new Date().getTime()/1000
      var duration = parseInt(ts - this.simcard.traffic.ts_update);
      let minutes = 0
      let hours = parseInt((duration/(60*60)));
      if (hours < 5) {
        minutes = parseInt((duration/60));
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }
      minutes = parseInt((duration/60)%60);
      return hours + " " + this.translate('simcard_devices.h_ago')
    },

    get_status_from(){
      return this.translate('from') + ' ' + this.get_date(this.simcard.ts_status_update);
    },
    created(){
      return this.get_date(this.simcard.ts_create)
    }
  },

  watch : {
    profile: {
      deep: true,
      handler () {
        this.update_sim()
        this.check_links(this.simcard)
      }
    }
  },

  methods: {
    blockedEsim(){
      let new_status = this.simcard.blocked === 1 ? 0 : 1
      var t = this.$createElement(ModalBlock, {
        props: {
          new_status,
          simcard: this.simcard
        },
        on: {
          close: () => { this.$modal.hide('dynamic-modal') },
          update: () => { this.$emit('change') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'dynamic-modal'})
    },
    check_links (sim) {
      let msisdn = sim.msisdn ? sim.msisdn : sim.number
      this.$http.simcard.getAllSimcards(msisdn, sim.iccid, sim.imsi, (response) => {
        let links = response.data
        for (let index in links) {
          if (index === 'status' || index === 'esim_profile') {
            delete(links[index])
          }
        }
        this.links = links
        },
        (bad_answer) => {
          this.bad_answer_handler(bad_answer)
        }
      )
    },
    download_to_device(){
      let t = this.$createElement(DownloadToDevice, {
        props:{
          iccid: this.simcard.iccid
        },
        on: {
          close: () => { this.$modal.hide('dynamic-modal') },
          update: () => { this.$emit('change') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    upload_to_device(){
      let t = this.$createElement(UploadToDevice, {
        props:{
          esim_id: this.simcard.id
        },
        on: {
          close: () => { this.$modal.hide('dynamic-modal') },
          update: () => { this.$emit('change') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    update_sim(){
      this.simcard = {...this.profile}
      !this.simcard.number ? this.editNumber = false : this.editNumber = true
      !this.simcard.operator ? this.editOperator = false : this.editOperator = true
    },
    simcard_status_text(status){
      switch (status) {
        case -1: return this.translate('simcard_profile.status_info.undefined')
        case 1: return this.translate('simcard_profile.status_info.active')
        case 2: return this.translate('simcard_profile.status_info.blocked')
        case 3: return this.translate('simcard_profile.status_info.prepare')
        case 4: return this.translate('simcard_profile.status_info.stop')
      }
    },
    simcard_status_color(status){
      switch (status) {
        case -1: return 'gray'
        case 1: return 'green'
        case 2: return 'yellow'
        case 3: return 'blue'
        case 4: return 'red'
      }
    },
    check_empty(data){
      return !!data;
    },

    cancel () {
      this.init = true
      this.simcard = {...this.profile}
    },
  }
}

</script>

<style lang='scss' scoped>
  .card{
    padding-left: 0;
    padding-right: 0;
    width: 64.5%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    &__wrap{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .header-profile {
      padding: 10px 8px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      min-height: 74px;
      height: 120px;
      &.blocked{
        border: 2px solid #f3bb45;
        padding-left: 130px;
        .esim_blocked{
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 125px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f3bb45;
          color: white;
          font-size: 12px;
          span{
            text-align: center;
          }
        }
      }
      .icons{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .badge{
          padding: 10px;
          font-size: 16px;
        }
        .last_update{
          text-align: center;
          span{
            display: block;
          }
        }

      }

      .download_to_device{
        margin: 0 10px;
        border-radius: 10px;
        box-shadow: 0 2px 2px #ccc5b980;
        color: #252422;
        padding-bottom: 0;
        position: relative;
        border: 1px solid #ccc;
        background-color: #f8f8f8;
        min-width: 200px;
        height: 100%;
        h4.title {
          font: 300 12px/16px "Roboto", Arial, sans-serif;
          color: #000;
          background: #f4f3ef;
          padding: 5px 10px;
          border-radius: 10px 10px 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .current{
          padding: 0 5px;
          border-top: 1px solid #ccc;
          .version {
            font-size: 10px;
            color: #9A9A9A;
            text-align: center;
            padding: 5px 0 0;
            span{
              display: block;
            }
          }
          button{
            display: block;
            margin: 5px auto;
          }
        }
        .download{
          height: 70%;
          border-top: 1px solid #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .linked-cards{
        height: 100px;
        display: flex;
        cursor: pointer;
        margin-left: auto;
        .linked-card__wrap{
          height: 100%;
          margin-right: 5px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }

    .content{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .traffic {
        --p:20;
        --b:20px;
        --c:darkred;
        --w:150px;

        width: 150px;
        aspect-ratio: 1;
        position:relative;
        place-content:center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        p{
          font-size: 12px;
          line-height: 120%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        &:before,
        &:after {
          content:"";
          position:absolute;
          border-radius:50%;
        }

        &:before {
          inset:0;
          background:
            radial-gradient(farthest-side,var(--c) 98%,#0000) top/var(--b) var(--b) no-repeat,
            conic-gradient(var(--c) calc(var(--p)*1%),#0000 0);
          mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
          background-size:0 0,auto;
          z-index: 1;
        }
        &:after {
          border: 20px solid #e3e3e3;
          width: 100%;
          height: 100%;
        }

        &__wrap{
          width: 150px;
          margin: 5px;
          margin-right: 20px;

          .last_update{
            margin-top: 5px;
            text-align: center;
            display: inline-block;
            width: 100%;
            p{
              font-size: 12px;
              margin-bottom: 0;
            }
          }
        }
      }

      .simcard-profile{
        width: 100%;
      }
    }

    .button_div {
      padding-bottom: 10px;
      padding-top: 5px;
    }

    .table_ip_tr {
      background-color: #eee !important;
    }
  }

  .history_action__wrap{
    width: 34.5%;
    height: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
  }

  .simcard_list{
    padding: 0 8px;
  }

  @media (max-width:1350px){
    .card{
      width: 100%;
      height: auto;
      min-height: inherit;
      margin-bottom: 10px;
      &__wrap{
        height: auto;
        flex-direction: column;
        padding-bottom: 10px;
      }
    }
    .history_action__wrap{
      width: 100%;
      height: auto;
    }
  }

  @media (max-width:600px){
    .card{
      .header-profile {
        align-items: center;
        flex-direction: column;
        height: auto;
        &>div{
          margin: 5px;
        }
        .linked-card__wrap{
          margin-left: 5px;
          height: 90px;
        }
      }
    }
  }

  @media (max-width:500px){
    .card{
      .content{
        align-items: center;
        flex-direction: column;
      }
    }
  }
</style>
